import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useKioskMode, KioskOrderTypeCode } from '../../contexts/KioskModeContext';
import { saveGuestOrderType } from '../../utils/guestOrderTypeStorage';
import { kioskCodeToGuestType } from './kioskGuestOrderType';
import { kioskMenuPath } from './kioskPaths';
import styles from './KioskOrderType.module.css';

const KioskOrderType: React.FC = () => {
  const { appName } = useParams<{ appName: string }>();
  const navigate = useNavigate();
  const { orderTypes } = useKioskMode();

  useEffect(() => {
    if (!appName) return;
    if (orderTypes.length === 1) {
      saveGuestOrderType(appName, kioskCodeToGuestType(orderTypes[0]));
      navigate(kioskMenuPath(appName), { replace: true });
    }
  }, [appName, orderTypes, navigate]);

  if (!appName || orderTypes.length <= 1) {
    return null;
  }

  const select = (code: KioskOrderTypeCode) => {
    saveGuestOrderType(appName, kioskCodeToGuestType(code));
    navigate(kioskMenuPath(appName));
  };

  const showDineIn = orderTypes.includes('DINEIN');
  const showTakeaway = orderTypes.includes('TAKEAWAY');

  return (
    <div className={styles.page}>
      <h1 className={styles.title}>How are you ordering?</h1>
      <p className={styles.subtitle}>Tap one to continue</p>
      <div className={styles.grid}>
        {showDineIn && (
          <button type="button" className={styles.btn} onClick={() => select('DINEIN')}>
            <span className={styles.label}>Dine-in</span>
            <span className={styles.hint}>Eat here</span>
          </button>
        )}
        {showTakeaway && (
          <button type="button" className={`${styles.btn} ${styles.takeaway}`} onClick={() => select('TAKEAWAY')}>
            <span className={styles.label}>Takeaway</span>
            <span className={styles.hint}>Pick up at counter</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default KioskOrderType;
